module.exports = __webpack_public_path__ + "img/cabin_bag.6ddfcd9e.png";